import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import { Heading, P, SectionHeading, SectionWrapper, } from "../../../Styles/style";

const Custom = styled(Grid)`
  padding: 5px 0;
  @media screen and (max-width: 1105px) {
    /* padding: 150px 0 70px 0px; */
  }
`;
const LineImg = styled.img`
width: 100%;
/* max-width: 200px; */
`;
const TOtalSupply = styled.div`

background-color:#000;
  padding:6px 0;
`
const Liqi = styled.div`
background-color:#73BB61;
  padding:6px 0;
`
const Cex = styled.div`
background-color: ${(props) => props.bgcolor ? props.bgcolor : "#59A447"};
  padding:6px 0;
`
const Index = () => {
  return (
    <div>
      <SectionWrapper bgColor="#CF2829" p="4rem 0" id="pehnomics">
        <Container >
          <SectionHeading color="#fff" p="40px 0" align="center" data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="200"
                data-aos-offset="0"
                data-aos-duration="500">
            Pehnomics
          </SectionHeading>

          <Custom container rowSpacing={1} columnSpacing={3} justifyContent="Center">
            <Grid item xs={12}>
              <TOtalSupply data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-offset="0"
                data-aos-duration="500"><Heading align="center" color="#fff">Total Supply: 1 Billion</Heading></TOtalSupply>
            </Grid>
            <Grid item xs={6}>
              <TOtalSupply data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="500"
                data-aos-offset="0"
                data-aos-duration="500"><Heading align="center" color="#fff">Buy Tax: 1</Heading></TOtalSupply>
            </Grid>
            <Grid item xs={6}>
              <TOtalSupply data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="600"
                data-aos-offset="0"
                data-aos-duration="500"><Heading align="center" color="#fff">Sell Tax: 1</Heading></TOtalSupply>
            </Grid>

          </Custom>
            <Custom container rowSpacing={0} columnSpacing={0} justifyContent="Center">
              <Grid item xs={6} sm={12}>
                <Liqi data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-offset="0"
                data-aos-duration="500"><Heading pt630="0 10px" fs599="11px" color="#fff" align="left" p="0 20px">100% Liquidity</Heading></Liqi>
              </Grid>

              {/* <Grid item xs={4} sm={2.5}>
                <Cex data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="800"
                data-aos-offset="0"
                data-aos-duration="500"><Heading pt630="0 10px"  fs599="11px" align="left" p="0 20px" color="#fff">4% Cex</Heading></Cex>
              </Grid>
              <Grid item xs={4} sm={2.5}>
                <Cex data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="900"
                data-aos-offset="0"
                data-aos-duration="500"bgcolor="#47853E"><Heading  fs599="11px"  pt630="0 10px"  align="left" p="0 20px" color="#fff">4% Airdrop</Heading></Cex>
              </Grid> */}
              {/* <P data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="1000"
                data-aos-offset="0"
                data-aos-duration="500" color="#FFF">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
Lorem ipsum dolor sit amet,.</P>   */}
            </Custom>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default Index;
